module.exports = __webpack_public_path__ + "static/media/householdInsurance_header_image.5b20a43e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/householdInsurance_header_image.png
// module id = 335
// module chunks = 21